import { http } from 'vue'

export default {
  // create company_sku_identifiers at the API server
  postCompanySkuIdentifier (context, params = {}) {
    return http.post('company_sku_identifiers?company_id=' + params.company_id, params.data)
  },
  // update company_sku_identifiers at the API server
  putCompanySkuIdentifier (context, params = {}) {
    return http.put('company_sku_identifiers/' + params.id + '?company_id=' + params.company_id, params.data)
  },
  // delete company_sku_identifiers at the API server
  deleteCompanySkuIdentifier (context, params = {}) {
    return http.delete('company_sku_identifiers/' + params.id + '?company_id=' + params.company_id, {body: params.data})
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/company_sku_identifiers/actions.js